import { money } from './format.js';

// Positions the pricing vendor cannot value: an annuity contract, a separate
// account, a private fund. They are real money on the client's statement, and
// leaving them off the page is how a $400,000 annuity once reached a delivered
// report unmentioned. Client-facing and deliberately printed: it is a fact
// about their own money, not an internal note.

export default function UnpricedHoldings({ unpriced }) {
  if (!unpriced) return null;

  const { rows, unpricedValue, pricedValue, totalValue } = unpriced;
  const one = rows.length === 1;

  return (
    <div className="asmt-unpriced">
      <h3 className="asmt-subhead">
        {one ? 'One holding has no market price' : `${rows.length} holdings have no market price`}
      </h3>
      <p className="asmt-note">
        {one ? 'This is part of what you own' : 'These are part of what you own'}, but there is no
        daily market price behind {one ? 'it' : 'them'}. An annuity contract, for example, is valued
        by the insurance company rather than traded on an exchange. {one ? 'It counts' : 'They count'}{' '}
        in full toward your total, and {one ? 'it is' : 'they are'} left out of the cost and
        performance figures above, because there is no published expense ratio or price history to
        work them out from.
      </p>

      <table className="asmt-table">
        <thead>
          <tr>
            <th>Holding</th>
            <th>Account</th>
            <th className="num">Value</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((h, i) => (
            <tr key={`${h.ticker || h.name}-${i}`}>
              <td>
                <strong>{h.name || h.ticker || 'Position'}</strong>
                {h.name && h.ticker ? <span className="asmt-muted"> · {h.ticker}</span> : null}
              </td>
              <td>{h.account || <span className="asmt-muted">not stated</span>}</td>
              <td className="num">{money(h.value)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* The three figures have to add up on the page, because the whole point
          is that nothing quietly disappears between them. */}
      <div className="asmt-recon">
        <div className="asmt-recon-row">
          <span>Holdings with a market price</span>
          <span>{money(pricedValue)}</span>
        </div>
        <div className="asmt-recon-row">
          <span>Holdings without a market price</span>
          <span>{money(unpricedValue)}</span>
        </div>
        <div className="asmt-recon-row is-total">
          <span>Total from your statements</span>
          <span>{money(totalValue)}</span>
        </div>
      </div>
    </div>
  );
}
